export const KEY_PREFIX = `${process.env.VUE_APP_NAME}_Web_1`;

export const readFromLocalStorage = key => {
  try {
    if (typeof localStorage !== "undefined" && key) {
      const value = localStorage.getItem(`${KEY_PREFIX}_${key}`);

      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
  } catch (e) {
    // console.log(
    //   "localStorageHandler.readFromLocalStorage:exception:",
    //   e.message
    // );
  }
};

export const saveToLocalStorage = (key, value) => {
  try {
    if (typeof localStorage !== "undefined" && key && value)
      return typeof value === "object"
        ? localStorage.setItem(`${KEY_PREFIX}_${key}`, JSON.stringify(value))
        : localStorage.setItem(`${KEY_PREFIX}_${key}`, value);
  } catch (e) {
    // console.log("localStorageHandler.saveToLocalStorage:exception:", e.message);
  }
};

export const removeFromLocalStorage = key => {
  try {
    if (typeof localStorage !== "undefined" && key)
      return localStorage.removeItem(`${KEY_PREFIX}_${key}`);
  } catch (e) {
    // console.log(
    //   "localStorageHandler.removeFromLocalStorage:exception:",
    //   e.message
    // );
  }
};
